export default "__VITE_ASSET__b47b0729__"